import { render, staticRenderFns } from "./BaseSet.vue?vue&type=template&id=56bb68ef&scoped=true&"
import script from "./BaseSet.vue?vue&type=script&lang=js&"
export * from "./BaseSet.vue?vue&type=script&lang=js&"
import style0 from "./BaseSet.vue?vue&type=style&index=0&id=56bb68ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb68ef",
  null
  
)

export default component.exports